import React, { useEffect, useState } from "react";
import {
	MDBBtn,
	MDBCard,
	MDBCardBody,
	MDBCardFooter,
	MDBIcon,
	MDBInput,
	MDBSpinner,
	MDBValidation,
	MDBValidationItem,
} from "mdb-react-ui-kit";
import { connect, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { register, setRegisterError } from "./action";
import { selectRegisterError } from "./selectors";
import { createStructuredSelector } from "reselect";

import logo from "../../Assets/logo.png";
import { selectIsLoading } from "../../Containers/App/selector";
import style from "./style.module.scss";
import { encryptCipher } from "../../Utils/EncryptionHelper";

const initialState = {
	firstName: "",
	lastName: "",
	email: "",
	password: "",
};

const Register = ({ isLoading, registerError }) => {
	const [formValue, setFormValue] = useState(initialState);
	const { firstName, lastName, email, password, confirmPassword } = formValue;
	const [isRegister, setIsRegister] = useState(false);

	const dispatch = useDispatch();

	useEffect(() => {
		toast.error(registerError);
		dispatch(setRegisterError(null));
	}, [registerError]);

	const onInputChange = (e) => {
		let { name, value } = e.target;
		setFormValue({ ...formValue, [name]: value });
	};
	const onSuccessRegister = () => {
		toast.success("Successfully registered!");
		setIsRegister(true);
	};
	const onSubmitHandle = (e) => {
		e.preventDefault();
		if (password !== confirmPassword) {
			return toast.error("Password should match!");
		}
		if (firstName && lastName && email && password) {
			const data = { firstName, lastName, email, password: encryptCipher(password) };
			dispatch(register(data, onSuccessRegister));
		}
	};
	if (isRegister) {
		return (
			<div className={style.container}>
				<div>
					<div className={style.iconContainer}>
						<div className={style.iconSuccess}>
							<MDBIcon fas icon='check' size='4x' className={style.icon} />
						</div>
					</div>
					<h3 className={style.iconText}> Account successfully created!</h3>
					<p className={style.descText}>
						Your account is successfully created! Please confirm your email by
						clicking a button in our confirmation mail!
					</p>
				</div>
				<div className={style.btnContainer}>
					<Link to='/login' className={style.btnLogin}>
						Sign in
					</Link>
				</div>
			</div>
		);
	}
	return (
		<div className={style.registerContainer} style={{}}>
			<MDBCard alignment='center'>
				<div className='mb-1 rounded-circle mt-4'>
					<img src={logo} alt='logo' className={style.logo} />
				</div>
				<MDBCardBody>
					<MDBValidation
						onSubmit={onSubmitHandle}
						noValidate
						className='row g-3'
					>
						<MDBValidationItem
							className='col-md-6'
							invalid
							feedback='Please provide your first name'
						>
							<MDBInput
								label='First Name'
								type='text'
								value={firstName}
								name='firstName'
								onChange={onInputChange}
								required
							/>
						</MDBValidationItem>
						<MDBValidationItem
							className='col-md-6'
							invalid
							feedback='Please provide your last name'
						>
							<MDBInput
								label='Last Name'
								type='text'
								value={lastName}
								name='lastName'
								onChange={onInputChange}
								required
							/>
						</MDBValidationItem>
						<MDBValidationItem
							className='col-md-12'
							invalid
							feedback='Please provide your email'
						>
							<MDBInput
								label='Email'
								type='email'
								value={email}
								name='email'
								onChange={onInputChange}
								required
							/>
						</MDBValidationItem>
						<MDBValidationItem
							className='col-md-12'
							invalid
							feedback='Please provide your password'
						>
							<MDBInput
								label='Password'
								type='password'
								value={password}
								name='password'
								onChange={onInputChange}
								required
							/>
						</MDBValidationItem>
						<MDBValidationItem
							className='col-md-12'
							invalid
							feedback='Please provide your confirm password'
						>
							<MDBInput
								label='Confirm Password'
								type='password'
								value={confirmPassword}
								name='confirmPassword'
								onChange={onInputChange}
								required
								checked
							/>
						</MDBValidationItem>
						<div className='col-md-12'>
							<MDBBtn
								style={{ width: "100%" }}
								className={`mt-2 ${style.defaultBtn}`}
								disabled={
									firstName && lastName && email && password && confirmPassword
										? false
										: true
								}
							>
								{isLoading && (
									<MDBSpinner
										size='sm'
										role='status'
										tag='span'
										className='me-2'
									/>
								)}
								Sign Up
							</MDBBtn>
						</div>
					</MDBValidation>
				</MDBCardBody>
				<MDBCardFooter>
					<Link to='/login'>
						<p>Already have an account ? Sign In</p>
					</Link>
				</MDBCardFooter>
			</MDBCard>
		</div>
	);
};

const mapStateToProps = createStructuredSelector({
	registerError: selectRegisterError,
	isLoading: selectIsLoading,
});

export default connect(mapStateToProps)(Register);
